import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { VULN_ISSUE_TYPE } from '../../../../../shared/issuesV2';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import { ExportIssuesModalDetailsContainer } from '../../modals';
import { useIssueDetailsModals } from '../IssueDetailsModalsContext';

type Props = {
  /** The upgrade version the user selected, seeded into the ticket content. */
  remediationVersion?: string;
};

/**
 * The Jira export modal instance owned by the fossabot remediation boxes.
 * Uses its own fossabotExport modal state (not the Actions bar's exportModal)
 * so the selected upgrade version can seed the ticket content, and so
 * isAnyModalOpen keeps the issue drawer open behind the modal.
 */
export const FossabotExportTicketModal: VoidFunctionComponent<Props> = ({ remediationVersion }) => {
  const issue = useSelector(IssuesV2Store.selectors.getIssueDetails);
  const { fossabotExportModal } = useIssueDetailsModals();

  if (!issue || issue.type !== VULN_ISSUE_TYPE.Vulnerability) {
    return null;
  }

  return (
    <ExportIssuesModalDetailsContainer
      id={issue.id}
      issue={issue}
      show={fossabotExportModal.isOpen}
      onHide={fossabotExportModal.onClose}
      remediationVersion={remediationVersion}
    />
  );
};
